import { makeStyles } from '@material-ui/styles';

export const useAlertsStyles = makeStyles(() => ({
  alert: {
    fontSize: (props) => (props.mobile ? 14 : 15),
    textAlign: 'left',
    borderRadius: '3px',
  },
}));
